/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/ComponentGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Component Groups
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:05 PM (CST)
 *  
 *  Notes:
 *      09/15/2018  NJN     Working on clean up to split out or eliminate code.
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    COMPONENTGROUP_LIST_CONTAINER_LOADED,
    COMPONENTGROUP_LIST_CONTAINER_UNLOADED,
    COMPONENTGROUP_LIST_TABLE_LOADED,
    COMPONENTGROUP_LIST_TABLE_UNLOADED,
    COMPONENTGROUP_SELECT_ROW,
    COMPONENTGROUP_ADD,
    COMPONENTGROUP_EDIT,
    COMPONENTGROUP_DELETE,
    COMPONENTGROUP_DELETE_DISABLE,
    COMPONENTGROUP_OPEN_WARNING,
    COMPONENTGROUP_CLOSE_WARNING,
    COMPONENTGROUP_VIEW_COMPONENTS,
    COMPONENTGROUP_EDIT_CONTAINER_LOADED,
    COMPONENTGROUP_EDIT_CONTAINER_UNLOADED,
    COMPONENTGROUP_EDIT_FORM_LOADED,
    COMPONENTGROUP_EDIT_FORM_UNLOADED,
    COMPONENTGROUP_EDIT_DATA_LOAD,
    COMPONENTGROUP_EDIT_CONTAINER_SUBMIT,
    COMPONENTGROUP_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeComponentGroups';

const defaultState = {
    refreshList: false,
    componentgroups: [],
    danger: false,
    componentgroupid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case COMPONENTGROUP_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                componentgroups: action.payload ? action.payload.componentgroups : []
            }
        case COMPONENTGROUP_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case COMPONENTGROUP_SELECT_ROW:
            return {
                ...state,
                componentgroupid: action.id
            }
        case COMPONENTGROUP_ADD:
            return {
                ...state
            }
        case COMPONENTGROUP_EDIT:
            return {
                ...state,
                componentgroupid: action.id
            }
        case COMPONENTGROUP_DELETE:
            return {
                ...state,
                componentgroupid: null
            }
        case COMPONENTGROUP_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case COMPONENTGROUP_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case COMPONENTGROUP_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case COMPONENTGROUP_VIEW_COMPONENTS:
            return {
                ...state
            }
        case COMPONENTGROUP_EDIT_CONTAINER_LOADED:
        case COMPONENTGROUP_EDIT_DATA_LOAD:
            return {
                ...state,
                componentgroupid: action.payload ? action.payload.componentgroupid : 0,
                name: action.payload ? action.payload.name : '',
                description: action.payload ? action.payload.description : '',
                createdate: action.payload ? action.payload.createdate : '',
                modifydate: action.payload ? action.payload.modifydate : ''
            }
        case COMPONENTGROUP_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case COMPONENTGROUP_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case COMPONENTGROUP_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case COMPONENTGROUP_LIST_CONTAINER_UNLOADED:
        case COMPONENTGROUP_LIST_TABLE_UNLOADED:
        case COMPONENTGROUP_EDIT_CONTAINER_UNLOADED:
        case COMPONENTGROUP_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/ComponentGroups.js